import React, { useState, useEffect } from 'react';

interface CountdownFarewellSectionProps {
  departureDate: Date;
  language: 'en' | 'mr';
}

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const CountdownFarewellSection: React.FC<CountdownFarewellSectionProps> = ({ departureDate, language }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const eventTime = departureDate.getTime();
      const difference = eventTime - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [departureDate]);

  const CountdownBox = ({ value, label }: { value: number; label: string }) => (
    <div className="group relative">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-pink-500 rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-all" />
      <div className="relative bg-slate-900 border-2 border-blue-400 rounded-xl p-6 hover:border-pink-400 transition-all transform hover:scale-110">
        <div className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-pink-300 animate-pulse">
          {String(value).padStart(2, '0')}
        </div>
        <div className="text-sm text-gray-400 uppercase tracking-widest mt-2">
          {label}
        </div>
      </div>
    </div>
  );

  return (
    <section className="relative py-24 px-4 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto">
        <h2 className="text-center text-4xl md:text-5xl font-black text-white mb-16">
          {language === 'mr' ? '⏳ बाकी वेळ' : '⏳ Time Until Departure'}
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto">
          <CountdownBox value={timeLeft.days} label={language === 'mr' ? 'दिवस' : 'Days'} />
          <CountdownBox value={timeLeft.hours} label={language === 'mr' ? 'तास' : 'Hours'} />
          <CountdownBox value={timeLeft.minutes} label={language === 'mr' ? 'मिनिटे' : 'Minutes'} />
          <CountdownBox value={timeLeft.seconds} label={language === 'mr' ? 'सेकंद' : 'Seconds'} />
        </div>

        <div className="text-center mt-12 text-gray-400 text-sm">
          ✈️ {language === 'mr' ? 'नव्या साहसाचे आवाहन' : 'An adventure awaits!'}
        </div>
      </div>
    </section>
  );
};
